import { HttpInterceptorFn } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';

export const ACCESS_TOKEN = new InjectionToken<() => string | undefined>('app.accessToken');

export const loginInterceptor: HttpInterceptorFn = (req, next) => {
  const getAccessToken = inject(ACCESS_TOKEN);
  const accessToken = getAccessToken();

  if (accessToken) {
    req = req.clone({
      headers: req.headers.set('authorization', `Bearer ${accessToken}`),
    });
  }

  return next(req);
};
